import { Component, OnInit } from '@angular/core';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { CommonModule } from '@angular/common';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { OvenOnOffBarComponent } from '../oven-on-off-bar/oven-on-off-bar.component';
import { OvenGaugesComponent } from '../oven-gauges/oven-gauges.component';
import { GaugeChartComponent } from "../../client/device-detail-nxt/gauge-chart-component/gauge-chart-component.component";
import { OvenAlertSummaryComponent } from "../oven-alert-summary/oven-alert-summary.component";
import { OvenHealthStatusComponent } from '../oven-health-status/oven-health-status.component';
import { MatButtonModule } from '@angular/material/button';
import { JobDialogBoxComponent } from '../job-dialog-box/job-dialog-box.component';
import { Router, RouterModule } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { debounce, update } from 'lodash';
import { ThresholdDialBoxComponent } from '../threshold-dial-box/threshold-dial-box.component';
import moment from 'moment';
import { OvenCommentDialogComponent } from '../oven-comment-dialog/oven-comment-dialog.component';
import { OvenJobListComponent } from '../oven-job-list/oven-job-list.component';
import { DoorComponentModal } from './door-comment-modal/door-comment-modal.component';
import { DoorOpenCommentsModal } from './door-open-comments-modal/door-open-comments-modal.componet';
import { MatIconModule } from '@angular/material/icon';
import { OvenMeasurementsRecordsComponent } from '../oven-measurements-records/oven-measurements-records.component';


@Component({
  selector: 'app-oven-dashboard',
  templateUrl: './oven-dashboard.component.html',
  styleUrls: ['./oven-dashboard.component.scss'],
  styles: [],
  standalone:true,
  imports: [CommonModule, MatMenu, MatMenuModule, OvenOnOffBarComponent, OvenGaugesComponent, GaugeChartComponent, OvenAlertSummaryComponent, OvenAlertSummaryComponent, OvenHealthStatusComponent, MatButtonModule, RouterModule,DoorComponentModal,DoorOpenCommentsModal,MatIconModule]
})
export class OvenDashboardComponent implements OnInit {
  public company_name : string;
  public onoffStatus: boolean = true;
  public monitoringDeviceDetailsLoader: boolean = false;
  public temperatureLoading: boolean = true;
  public monitoringMeterShowVelocity: any;
  public ovenParametersGuageData= [];
  public canvasWidth:number = 160;
  public dialogRef: MatDialogRef<JobDialogBoxComponent>;
  public baseOvenUrl = BaseUrlConstantsService.OVEN_BASE_URL;
  public serialNo:string = "oven";
  public latestFileTime : string;
  isAddingDoorComment:boolean=false;
  all_door_comments_modal:boolean=false;
  selected_oven_open_id=null;
  selectedDoorCommnet={};
  selected_comment_type='job'
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Assets",
    },
    {
      page_ref: "#",
      page_title: "Oven Dashboard",
    },
  ];
  public filteredJobs : any = [];
  public connectivityType: string = "wifi";
  public today: Date;
  public MonitoringMagacoustic: {
    needleValue: any;
    centralLabel: any;
    outerNeedle: boolean;
    canvasWidth: number;
    canvasHeight:number;
    name: any;
    key: any;
    bottomLabel: string;
    hasneedle: any;
    options: {
      hasNeedle: any;
      needleColor: string;
      needleUpdateSpeed: string;
      arcColors: any;
      arcLabels: any[];
      arcDelimiters: any;
      rangeLabel: any;
      needleStartValue: number;
    };
  };
  public ovenId: any;
  public clientId: any;
  public tabName: any ='tab-7';
  public tab1: boolean;
  public tab2: boolean  ;
  public tab3: boolean;
  public tab4: boolean;
  public subsystemId: any;
  public deviceStatus : string = 'Online';
  GraphScaleSettingData: any[];
  ovenPramStatusLoading: boolean ;
  dataGadge: any;
  Itemsymbol: any;
  gaugeShow: boolean;
  windingtemperatureloading: boolean;
  role: string;
  currentvalue: any;
  public doorStatusList: any = [];
  disable_door_comment=true;
  oven_extra_info:{oven_name:string,site_name:string,application_name:string}={oven_name:'N/A',site_name:'N/A',application_name:'N/A'};
  constructor(private router: Router,
    private dialog : MatDialog,
    public service: BackendApiService,
  ) { 
    this.subsystemId = localStorage.getItem("subsystem_id");
    this.role = localStorage.getItem("role");
    if(this.role == "ADMIN"){
      this.clientId =localStorage.getItem("admin_client_id");
    }else{
      this.clientId = localStorage.getItem("user_id");
    }
    this.ovenId = localStorage.getItem("oven_id");
    this.onSearchInput = debounce(this.onSearchInput.bind(this), 500);
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
    this.getJobData();  
  }
  
  openCommentList(){
    
  }

  viewJobList(){
    const dialogReff=  this.dialog.open(OvenJobListComponent, {
      width: '2200px',
      height:'800px',
      disableClose: true,
      data: { clientId : this.clientId,
          ovenId : this.ovenId,
       }
    });
  }

  async goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "oven-device-list",
        tabName: this.tabName,
        tab1: this.tab1,
        tab2 : this.tab2,
        tab3 : this.tab3,
        tab4 :this.tab4,
      },
    };
    let userRoll = localStorage.getItem("role");
    if(userRoll=='CLIENT' || userRoll=='USER')
      this.router.navigate(['/device-reports'],navigationExtras)
    else if(userRoll=='ADMIN'){
      this.router.navigate(['/device-report-new'],navigationExtras)
    }
  }
  onSearchInput(event:Event){
    console.log((event.target as HTMLInputElement).value.trim());

  }
  fetchData(query) {
    console.log("Fetching data for:", query);
    // Add your AJAX/fetch logic here
  }

  ngOnInit(): void {
    this.getOvenExtraInfo();
    this.getGaugesDataById();
    this.getLatestTimeDate();
    this.getDoorOpenCloseStatus();
    
  }
  
  getLatestTimeDate(){
    this.service.getData(`${this.baseOvenUrl}api/v1/oven-assets/latest_file_time/${this.clientId}/${this.subsystemId}/${this.ovenId}`)
    .then((res) =>{
       let response= JSON.parse(JSON.stringify(res))
      // if(response.data.status === 'success'){
        let datetime = response.data[0].updated_at;

// Parse UTC timestamp
        const lastTime = moment.utc(datetime);

        // Current UTC time
        const nowUtc = moment.utc();

        // Compare gap in minutes (UTC vs UTC, safe)
        const diffMinutes = nowUtc.diff(lastTime, "minutes");
      console.log(diffMinutes)
        if (diffMinutes > 1) {
          this.deviceStatus = "Offline";
        }
        const istDate = moment.utc(datetime)
                      .tz("Asia/Kolkata")
                      .format("YYYY-MM-DD HH:mm:ss");
                   this.latestFileTime    = istDate;
      // }
      console.log(this.deviceStatus,'devicestaus',this.latestFileTime)
    })
    
  }


   receiveData(event: string) {
    this.currentvalue = event;
    if(this.currentvalue  !== 0)this.deviceStatus = 'Online';
    else this.deviceStatus= 'Offline';
  }
  utcTime() {
      setInterval(() => {
        this.today = new ConvertDatetimePipe().convertDateTime(new Date());
      }, 1000);
    }
openRecordsDialogueBox(job_id:any){
  const dialogReff= this.dialog.open(OvenMeasurementsRecordsComponent, {
        width: '900px',
        height:"600px",
        disableClose: true,
        panelClass: 'custom-dialog-container',
        data:{
        client_id:this.clientId,
        job_number:job_id
        }
      });
}


    openJobForm(){
     const dialogReff= this.dialog.open(JobDialogBoxComponent, {
        width: '700px',
        disableClose: true,
        panelClass: 'custom-dialog-container',
        data:{
          type:"createjob",
          oven_id: this.ovenId,
          coil_values:this.dataGadge.map(gauge=>{return {name:gauge.name,value:gauge.value,key:gauge.metric_key}})
        }
      });
      dialogReff.afterClosed().subscribe(result =>{
        if(result && Object.keys(result).length > 0){
          console.log(result,'resulttttttttttttt');
          const jobData = {
            oven_id: this.ovenId, // manually set or get from elsewhere
            JOB_NO: result.JOB_NO,
            no_of_sensor: result.no_of_sensor,
            start_date: moment(result.start_date).utc().format('YYYY-MM-DD HH:mm:ss'),
            end_date: result.end_date || null,
            megger_value: Number(result.meggar_value) || 0,
            PI_value: Number(result.PI_value) || 0,
            sensor_serial_no_1: result.sensors?.[0]?.serial_no || '',
            sensor_serial_no_2: result.sensors?.[1]?.serial_no || '',
            sensor_serial_no_3: result.sensors?.[2]?.serial_no || '',
            sensor_serial_no_1_value: result.sensor_serial_no_1_value,
            sensor_serial_no_2_value: result.sensor_serial_no_2_value || '',
            sensor_serial_no_3_value: result.sensor_serial_no_3_value || '',
            supervisor_name: result.supervisor_name,
            client_id: this.clientId 
          };
          this.service.postData(`${this.baseOvenUrl}api/v1/oven-assets/jobs/create`,jobData).then((response:any) =>{
          // this.service.postData(`http://localhost:3024/api/v1/oven-assets/jobs/create`,jobData).then((response:any) =>{
            if(response.code === 200){
              // console.log(res)
             let body ={
                client_id: this.clientId,
                oven_id: this.ovenId,
                subsystem_id: this.subsystemId,
                comment_type: "job-comment",
                comment: result.comment,
                job_id: response.data,
                supervisor_name:result.supervisor_name
              }
              console.log(body,'bodybody')
              this.service.postData(`${this.baseOvenUrl}api/v1/oven-assets/add_comments`,body).then(res =>{
              // this.service.postData(`http://localhost:3024/api/v1/oven-assets/add_comments`,body).then(res =>{
                console.log(res,'res');

              })
              this.service.showSuccess(response.message);
              this.getJobData();
            }else{
              this.service.showError("Something went wrong!");
            }
          })
        }else{
        }
      })
    }
    getJobData(){
      this.service.getData(`${this.baseOvenUrl}api/v1/oven-assets/jobs/get/Active/${this.clientId}/${this.ovenId}`).then(response =>{
        let res = JSON.parse(JSON.stringify(response));
        if(res.code == 200){
          this.filteredJobs = res.data;
        }else{
          this.filteredJobs=[];
        }
        
      })
    }

    editJob(jobId){
      let coil_values=this.dataGadge.map(gauge=>{return {name:gauge.name,value:gauge.value,key:gauge.metric_key}})
      const  dislogReff = this.dialog.open(JobDialogBoxComponent, {
        width: '700px',
        panelClass: 'custom-dialog-coontainer',
        disableClose: true,

        data: {
          type:"editjob",
          jobId:jobId,
          oven_id: this.ovenId,
          subsystem_id:this.subsystemId,
          coil_values
        }
      });
      dislogReff.afterClosed().subscribe(result =>{
        if(result.code === 200){
          this.service.showSuccess(result.message);
          this.getJobData();
        }
      })
    }


    deleteJob(job_no){
      let dialogRef = this.dialog.open(JobDialogBoxComponent,{
        width: "400px",
        height: "210px",
        disableClose: true,
        data: {
          type: "delete-oven-dialog",
          JOB_NO: job_no
        },
      });
      dialogRef.afterClosed().subscribe(result =>{
        if(result.code === 200){
          this.service.showSuccess(result.message);
          this.getJobData();
        }else{
          this.service.showError('Something went wrong!')
        }
      })
    }
    public async getExformerGraphScaleSettingsDataByID(): Promise<any> {
      try {
        const sensorRes = await this.service
          .getDataWithQuery(
            `${this.baseOvenUrl}api/v1/oven-assets/tempreature-threshold/${this.clientId}/${this.subsystemId}`
          )
          .then((res) => {
            return res;
          });
        const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data;
  
        if (sensorBody && Object.keys(sensorBody).length !== 0) {
          return sensorBody;
        } else {
          throw new Error("No data found in sensor response");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        throw error; // Rethrow the error to be handled by the caller
      }
    }

    saveSettings(updatedSettings: any): void {
      // Implement saving logic using DataService
      // Example:
      this.service
        .putData(
          `${this.baseOvenUrl}api/v1/oven-assets/metrics/${this.clientId}/${this.subsystemId}`,
          updatedSettings
        )
        .then(
          (response:any) => {
            if (response.status === "success") {
               this.getGaugesDataById();
              // this.getLineDataByID();
            }
          },
          (error) => {
            console.error("Error saving settings:", error);
          }
        );
    }
    openOvenThresholdSetting(val): void {
      // this.loader = true;
      this.getExformerGraphScaleSettingsDataByID()
        .then((data: any) => {
          //set data into GraphScaleSettingData variable.
          this.GraphScaleSettingData = [];
          // let response = data;
          // this.GraphScaleSettingData.push({metric_type:metric_type, threshold_1:response[0].threshold_1,threshold_2:response[0].threshold_2,threshold_3:response[0].threshold_3,max_value:response[0].max_value,base_value:response[0].base_value});
          //Open Dialog Box.
          this.GraphScaleSettingData = val === 'temp_first_row'  ? data.slice(0, 7)
            : data.slice(data.length / 2 );
          // this.loader = false;
          const dialogRef = this.dialog.open(ThresholdDialBoxComponent, {
            width: "1250px",
            disableClose: true,
            data: {
              type: "allMertrics",
              dataAll: this.GraphScaleSettingData,
            },
          });
  
          // Closed Dialog box
          dialogRef.afterClosed().subscribe((updatedSettings) => {
            const { changedObjects, comment, supervisor_name } = updatedSettings;

            if(comment !== undefined && comment.trim() !== ""){
              let body ={
                client_id: this.clientId,
                oven_id: this.ovenId,
                subsystem_id: this.subsystemId,
                comment_type: "temperature-threshold",
                comment: comment,
                supervisor_name
              }
              this.service.postData(`${this.baseOvenUrl}api/v1/oven-assets/add_comments`,body).then(res =>{
              // this.service.postData(`http://localhost:3024/api/v1/oven-assets/add_comments`,body).then(res =>{
                console.log(res)
              })
            }
            if (changedObjects) {
              this.temperatureLoading = true;
              this.saveSettings(changedObjects);
            }
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          // this.loader = false;
          // Handle error here
        });
    }


    
openCommentDialog() {
  const dialogRef = this.dialog.open(OvenCommentDialogComponent, {
    width: '400px',
    disableClose: true
  });

  dialogRef.afterClosed().subscribe(comment => {
    if (comment) {
      let body = {
        client_id: this.clientId,
        subsystem_id: this.subsystemId,
        oven_id: this.ovenId,
        comment_type: "open-door",
        comment: comment
      }
      console.log('User comment:', comment);
      // Call your API or function to save comment
      this.service.postData(`${this.baseOvenUrl}api/v1/oven-assets/add_comments`,body).then((res:any) =>{
        console.log(res)
        if(res.code === 200){
          this.service.showSuccess("Comment saved successfully.");
        }else{
          this.service.showError("Something went wrong!")
        }
      })
    }
  });
}

    public async getGaugesDataById() {
      this.ovenPramStatusLoading = true;
      this.service
        .getDataWithQuery(
          // `http://localhost:3024/api/v1/oven-assets/params-data/${this.clientId}/${this.ovenId}/${this.subsystemId}`
          `${this.baseOvenUrl}api/v1/oven-assets/params-data/${this.clientId}/${this.ovenId}/${this.subsystemId}`
        )
        .then((sensorRes:any) => {
          // let sensorRes = JSON.parse(JSON.stringify(sRes)).data;
  
          if (sensorRes.data && Object.keys(sensorRes.data).length !== 0) {

            this.temperatureLoading = true;
            let response = sensorRes.data;
            this.ovenParametersGuageData = [];
            if (response != undefined) {
              if (response.length != 0) {
                this.dataGadge = response;
  
                if (this.dataGadge.length !== 0) {
                  this.temperatureLoading = false;
                  let tempArr = [];
                  let bottomLab = "";
                  for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                    if (
                      JSON.parse(this.dataGadge[mCount].value) === 0 &&
                      this.dataGadge[mCount].needle === false 
                    ) {
                      bottomLab = "NA";
                    } else {
                      bottomLab =
                        JSON.parse(this.dataGadge[mCount].value) < 0
                          ? "NA"
                          : this.dataGadge[mCount].symbol === "C"
                          ? JSON.parse(this.dataGadge[mCount].value) +
                            " °" +
                            "C"
                          : JSON.parse(this.dataGadge[mCount].value) 
                            
                    }
  
                    this.Itemsymbol = this.dataGadge[mCount].symbol;
                    let needleValueRes;
                    if (this.dataGadge[mCount].symbol === "m/sec²") {
                      needleValueRes
                      =
                        (JSON.parse(this.dataGadge[mCount].value) * 100) /
                        parseFloat(this.dataGadge[mCount].rangelabel[1]);
                    } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                      needleValueRes =
                        (JSON.parse(this.dataGadge[mCount].value) * 100) /
                        parseFloat(this.dataGadge[mCount].rangelabel[1]);
                    } else if (this.dataGadge[mCount].symbol === "deg") {
                      needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                    } else {
                      needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                      // needleValueRes =
                      //   (JSON.parse(this.dataGadge[mCount].value) * 100) /
                      //   parseFloat(this.dataGadge[mCount].rangelabel[1]);
                    }
                    let centerLab =
                      JSON.parse(this.dataGadge[mCount].value) < 0
                        ? "N/A"
                        : JSON.parse(this.dataGadge[mCount].value);
                    let arc_colors =
                      this.dataGadge[mCount].needle === true
                        ? this.dataGadge[mCount].arcColors
                        : ["transparent", "transparent", "transparent"];
                    let range_label =
                      this.dataGadge[mCount].needle === true
                        ? this.dataGadge[mCount].rangelabel
                        : [];
                    let arc_Delimiters =
                      this.dataGadge[mCount].needle === true
                        ? this.dataGadge[mCount].arcDelimiters
                        : [];
                    let value =
                      JSON.parse(this.dataGadge[mCount].value) < 0
                        ? "N/A"
                        : JSON.parse(this.dataGadge[mCount].value);
                        
                    const ovenParametersData = {
                      // value:value,
                      needleValue: needleValueRes,
                      centralLabel: '',
                      outerNeedle: false,
                      canvasWidth: 220,
                      name: this.dataGadge[mCount].name,
                      key: this.dataGadge[mCount].key,
                      bottomLabel: bottomLab,
                      hasneedle: this.dataGadge[mCount].needle,
                      options: {
                        hasNeedle: this.dataGadge[mCount].needle,
                        needleColor: "black",
                        needleUpdateSpeed: "",
                        arcColors: arc_colors,
                        arcLabels: [] as string[],
                        arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                        rangeLabel: range_label,
                        needleStartValue: 0,
                      },
                    };
                    if (
                      arc_Delimiters[0] < 100 &&
                      arc_Delimiters[0] > 0 &&
                      arc_Delimiters[1] > 0 &&
                      arc_Delimiters[0] < arc_Delimiters[1] &&
                      arc_Delimiters[1] < 100
                    ) {        
                      let max = range_label[1] != null ? range_label[1] : 0;
                      ovenParametersData.options.arcLabels[0] = Number(
                        this.dataGadge[mCount].arcDelimiters[0]
                      ).toFixed(1);
                      ovenParametersData.options.arcLabels[1] = Number(
                        this.dataGadge[mCount].arcDelimiters[1]
                      ).toFixed(1);
                      ovenParametersData.options.arcLabels[2] = Number(this.dataGadge[mCount].arcDelimiters[2]).toFixed(1);
                      ovenParametersData.options.arcLabels[3] = Number(this.dataGadge[mCount].arcDelimiters[3]).toFixed(1);
                      ovenParametersData.options.arcLabels[4] = Number(this.dataGadge[mCount].arcDelimiters[4]).toFixed(1);
                        

                      ovenParametersData.options.arcDelimiters[0] = ((parseFloat(ovenParametersData.options.arcLabels[0])/parseFloat(
                            ovenParametersData.options.rangeLabel[1]
                          ) -
                            parseFloat(
                              ovenParametersData.options.rangeLabel[0]
                            ))*100).toString();
                      ovenParametersData.options.arcDelimiters[1] = ((parseFloat(ovenParametersData.options.arcLabels[1])/parseFloat(
                            ovenParametersData.options.rangeLabel[1]
                          ) -
                            parseFloat(
                              ovenParametersData.options.rangeLabel[0]
                            ))*100).toString();
                      ovenParametersData.options.arcDelimiters[2]=((parseFloat(ovenParametersData.options.arcLabels[2])/parseFloat(
                            ovenParametersData.options.rangeLabel[1]
                          ) -
                            parseFloat(
                              ovenParametersData.options.rangeLabel[0]
                            ))*100).toString();
                      ovenParametersData.options.arcDelimiters[3]=((parseFloat(ovenParametersData.options.arcLabels[3])/parseFloat(
                            ovenParametersData.options.rangeLabel[1]
                          ) -
                            parseFloat(
                              ovenParametersData.options.rangeLabel[0]
                            ))*100).toString();
                      ovenParametersData.options.arcDelimiters[4]=((parseFloat(ovenParametersData.options.arcLabels[4])/parseFloat(
                            ovenParametersData.options.rangeLabel[1]
                          ) -
                            parseFloat(
                              ovenParametersData.options.rangeLabel[0]
                            ))*100).toString();
                      // let velocityG = sensorRes.data.rangeLabels.green;
                      // let velocityY = sensorRes.data.rangeLabels.yellow;
                      // let velocityR = max;
                      ovenParametersData.options.arcColors[0] = "#ff2a1b";
                      ovenParametersData.options.arcColors[1] = "#FAA700";
                      ovenParametersData.options.arcColors[2] = "#72FF13";
                      ovenParametersData.options.arcColors[3] = "#72FF13";
                      ovenParametersData.options.arcColors[4] = "#FAA700";
                      ovenParametersData.options.arcColors[5] = "#ff2a1b";
  
                      if (
                        ovenParametersData.centralLabel <=
                        ovenParametersData.options.arcLabels[0]
                      ) {
                        // accelerationData.options.centralLabel=
                        ovenParametersData.options.needleColor = "#ff2a1b";
                      } else if (
                        ovenParametersData.centralLabel >
                          ovenParametersData.options.arcLabels[0] &&
                        ovenParametersData.centralLabel <=
                          ovenParametersData.options.arcLabels[1]
                      ) {
                        ovenParametersData.options.needleColor = "#FAA700";
                      } else if(
                        ovenParametersData.centralLabel > ovenParametersData.options.arcLabels[1] &&
                        ovenParametersData.centralLabel <=
                          ovenParametersData.options.arcLabels[2]
                      ){
                         ovenParametersData.options.needleColor = "#72FF13";
                      } else if(
                        ovenParametersData.centralLabel > ovenParametersData.options.arcLabels[2] &&
                        ovenParametersData.centralLabel <=
                        ovenParametersData.options.arcLabels[3]
                      ){
                        ovenParametersData.options.needleColor = "#FAA700";
                      }
                      else {
                        ovenParametersData.options.needleColor = "#ff2a1b";
                      }
                      this.ovenParametersGuageData.push(ovenParametersData);
                      setTimeout(() => {
                        this.windingtemperatureloading = false;
                      }, 3000);
                      this.gaugeShow = true;
                      // this.ovenPramStatusLoading = false;
                      if (this.ovenParametersGuageData.length >= 1) {
                        // setTimeout(() => {
                        this.ovenPramStatusLoading = false;
                        // }, 100);
                      }
                      
                    }
                  }
                }
              }
            }
          }
        });
    }

    goToAdditionalParams() {
      this.router.navigate(
        ['/oven-additional-params'],
        {
          queryParams: { subsystemId: this.subsystemId, clientId: this.clientId },
          skipLocationChange: true // ✅ hides the URL change
        }
      );
    }

    getDoorOpenCloseStatus(){
      this.service.getData(`${this.baseOvenUrl}api/v1/oven-assets/get-door-time/${this.clientId}/${this.subsystemId}/${this.ovenId}`)
      // this.service.getData(`http://localhost:3024/api/v1/oven-assets/get-door-time/${this.clientId}/${this.subsystemId}/${this.ovenId}`)
      .then((res) =>{
        let response = JSON.parse(JSON.stringify(res));
        if(response.status === 'success'){
          this.doorStatusList = response.data;
          if(this.doorStatusList.length && this.doorStatusList[0].off_id)
            this.disable_door_comment=true;// disable as latest entry had closing id
          else
            this.disable_door_comment=false;// disable as latest entry had closing id
        }else{
          this.doorStatusList=[];
        }
      })
    }

    getOvenExtraInfo(){
      this.service.getData(`${this.baseOvenUrl}api/v1/oven-assets/get-oven-info/${this.ovenId}`)
      // this.service.getData(`http://localhost:3024/api/v1/oven-assets/get-oven-info/${this.ovenId}`)
      .then((res) =>{
        let response = JSON.parse(JSON.stringify(res));
        if(response.status === 'success'){
          this.oven_extra_info = response.data[0];
        }else{
          this.oven_extra_info=null;
        }
      })
    }
    addDoorComment(data:any,type:string){
      this.isAddingDoorComment=true;
      this.selectedDoorCommnet={...data,type,subsystem_id:this.subsystemId,oven_id:this.ovenId,client_id:this.clientId}
    }
    handleDoorCommentModalCancel() {this.isAddingDoorComment=false}
    
    handlegetAllDoorCommentsModal(item:any={},type='door'){
      this.selected_comment_type='door'
      if(item) this.selected_oven_open_id=item.on_id
      this.all_door_comments_modal=true
    }
    handlegetAllDoorCommentsModalCancel() {this.all_door_comments_modal=false;}
    
}

